import * as React from 'react';
import { StyleSheet, css, CSSProperties } from 'aphrodite/no-important';
import { useTheme } from '../../../../theming/useTheme';
import { DecorationLine } from '../../DecorationLine';
import { CardComponentDataProps } from '../../cards/dividedCard/DividedCard';
import { ListItem } from '../listItem/ListItem';
import { LIST_STYLE, LIST_WRAPPER_STYLE } from '../lists.const';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';

const componentConfigurationKey = 'list';
const createStyles = (
  backgroundColor: string,
) => StyleSheet.create({
  listWrapper: {
    ...LIST_WRAPPER_STYLE,
    backgroundColor,
  },
  list: {
    ...LIST_STYLE,
    [MEDIA_BREAKPOINTS.SMALL]: {
      position: 'relative',
    },
  },
});

interface ListComponentDataProps {
  listProps: CardComponentDataProps[],
}

interface ListComponentThemeProps {
  backgroundColor: string
  surfaceStyle: CSSProperties
}

type ListComponentProps = ListComponentDataProps & ListComponentThemeProps;

export const ListComponent: React.FunctionComponent<ListComponentProps> = (
  {
    listProps,
    backgroundColor,
    surfaceStyle,
  },
) => {
  const styles = createStyles(
    backgroundColor,
  );

  return (
    <div className={css(
      StyleSheet.create({ surfaceStyle }).surfaceStyle,
      styles.listWrapper,
    )}
    >
      <DecorationLine />
      <div className={css(styles.list)}>
        {listProps.map((listItemProps, index) => (<ListItem {...listItemProps} key={index} />))}
      </div>
    </div>
  );
};

ListComponent.defaultProps = {
  listProps: [],
};

const mapThemeToProps = (theme: ListComponentThemeProps) => ({
  backgroundColor: theme.backgroundColor,
  surfaceStyle: theme.surfaceStyle,
});

export const List = (props: ListComponentDataProps) => {
  const themeContext = useTheme(componentConfigurationKey, mapThemeToProps);
  return <ListComponent {...themeContext} {...props} />;
};
